import { useDispatch, useSelector } from "react-redux"

import { useEffect } from "react"
import { setBankVariants } from "../../../store/slices/settingsSBP"
import { RootState } from "../../../store/store"
import { usePermissionBankList } from "../../../api/hooks/usePermissionBankList"

export const useBankSelect = () => {
  const { data } = usePermissionBankList()

  const bankVariants = useSelector(
    (state: RootState) => state.settingsSBPForm.bankVariants,
  )

  const dispatch = useDispatch()

  useEffect(() => {
    if (data) {
      dispatch(setBankVariants(data))
    }
  }, [data, bankVariants])

  return {
    bankVariants,
  }
}
